import { render, staticRenderFns } from "./Characteristic.vue?vue&type=template&id=73684afc&"
import script from "./Characteristic.vue?vue&type=script&lang=js&"
export * from "./Characteristic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports